/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';

import useSiteMetadata from '../hooks/useSiteMetadata';

type Meta =
  | {
      name: string;
      content: string;
      property?: undefined;
    }
  | {
      property: string;
      content: string;
      name?: undefined;
    };

export interface SEOProps {
  description?: string;
  meta?: Meta[];
  title?: string;
}

export default function SEO({ description, meta: metaObjects = [], title }: SEOProps) {
  const siteMetadata = useSiteMetadata();

  if (!siteMetadata) {
    return <title>{title}</title>;
  }

  const finalDescription = description || siteMetadata.description;
  const finalTitle = title && title.length > 0 ? `${siteMetadata.title} | ${title}` : siteMetadata.title;

  const allMeta = [
    {
      name: `title`,
      content: finalTitle,
    },
    {
      name: `author`,
      content: siteMetadata.author?.name,
    },
    {
      name: `keywords`,
      content: siteMetadata.keywords,
    },
    {
      name: `description`,
      content: finalDescription,
    },
    // Twitter Cards API
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:site`,
      content: siteMetadata.social?.twitter,
    },
    {
      name: `twitter:title`,
      content: finalTitle,
    },
    {
      name: `twitter:description`,
      content: finalDescription,
    },
    {
      name: `twitter:creator`,
      content: siteMetadata.social?.twitter,
    },
    {
      name: `twitter:domain`,
      content: 'kristw.yellowpigz.com',
    },
    {
      name: 'twitter:image:src',
      content: siteMetadata.thumbnailUrl,
    },
    // Facebook Open Graph API
    {
      property: `fb:app_id`,
      content: siteMetadata.social?.fbAppId,
    },
    {
      property: `og:url`,
      content: siteMetadata.siteUrl,
    },
    {
      property: `og:title`,
      content: finalTitle,
    },
    {
      property: `og:site_name`,
      content: siteMetadata.title,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      property: `article:author`,
      content: siteMetadata.author?.name,
    },
    {
      property: `og:description`,
      content: finalDescription,
    },
    {
      property: 'og:image:type',
      content: 'image/png',
    },
    {
      property: 'og:image',
      content: siteMetadata.thumbnailUrl,
    },
  ].concat(metaObjects) as Meta[];

  return (
    <>
      <title>{finalTitle}</title>
      {allMeta.map((m) => (
        <meta key={m.name ?? m.property} {...m} />
      ))}
    </>
  );
}
